module.exports = __webpack_public_path__ + "img/friendly-pool-4.93834303.jpg";